<template>
  <div class="modal-overlay" @click.self="close">
    <div class="modal-content">
      <h2>Detalles del Expediente</h2>
      <div v-if="proceeding">
        <div class="proceeding-details">
          <div class="detail-row">
            <span class="detail-label">Expediente:</span>
            <span class="detail-value">{{ proceeding.number }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Descripción:</span>
            <span class="detail-value">{{ proceeding.description }}</span>
          </div>
        </div>
        <div v-if="user.id === proceeding.user_id" class="modal-actions">
          <button class="btn-edit" @click="$emit('edit', proceeding.id)"><i class="fas fa-edit"></i> Editar</button>
          <button class="btn-delete" @click="removeProceeding"><i class="fas fa-trash"></i> Eliminar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapGetters, mapActions } from 'vuex';

export default defineComponent({
  name: 'ProceedingModal',
  props: {
    proceedingId: {
      type: [String, Number],
      required: true
    }
  },
  computed: {
    ...mapGetters({ proceeding: 'stateProceeding', user: 'stateUser' }),
  },
  watch: {
    proceedingId: {
      immediate: true,
      handler(id) {
        if (id) this.fetchProceeding();
      }
    }
  },
  methods: {
    ...mapActions(['viewProceeding', 'deleteProceeding']),
    async fetchProceeding() {
      try {
        await this.viewProceeding(this.proceedingId);
      } catch (error) {
        this.close();
      }
    },
    async removeProceeding() {
      try {
        await this.deleteProceeding(this.proceedingId);
        this.$emit('deleted');
        this.close();
      } catch (error) {
        this.close();
      }
    },
    close() {
      this.$emit('close');
    },
  },
});
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}
.modal-content {
  background: #fff;
  border-radius: 18px;
  padding: 2rem 2.5rem;
  min-width: 340px;
  max-width: 95vw;
  box-shadow: 0 4px 32px 0 rgba(0,0,0,0.18);
  position: relative;
}
h2 {
  margin-bottom: 1.5rem;
  font-size: 1.5rem;
  font-weight: 700;
}
.proceeding-details {
  margin-bottom: 1.5rem;
}
.detail-row {
  display: flex;
  margin-bottom: 0.7rem;
}
.detail-label {
  font-weight: 600;
  min-width: 120px;
  color: #6c2eb7;
}
.detail-value {
  color: #222;
}
.modal-actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
}
.btn-edit {
  background: #a259e6;
  color: #fff;
  border: none;
  border-radius: 20px;
  padding: 0.5rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}
.btn-edit:hover {
  background: #6c2eb7;
}
.btn-delete {
  background: #fff;
  color: #e74c3c;
  border: 2px solid #e74c3c;
  border-radius: 20px;
  padding: 0.5rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.btn-delete:hover {
  background: #ffeaea;
  color: #c0392b;
}
</style>
